import { SITE_URLS } from '@constants';
import { matchPath, useLocation } from 'react-router-dom';

export const useUrlAnalyser = () => {
    const location = useLocation();

    // add leading '/' if not present
    // remove GET params
    const sanitizePath = (path: string) => {
        const pathWithoutGetParams = path.split('?')[0];
        return (pathWithoutGetParams.startsWith('/') ? pathWithoutGetParams : `/${pathWithoutGetParams}`)
    };
  
    const getMatchedRoute = (url: string) => {
        for (const routeKey in SITE_URLS) {
            // @ts-ignore
            const routePattern: string = SITE_URLS[routeKey];
            const match = matchPath(routePattern, url);
            if (match) {
                return routePattern;
            }
        }
        return null;
    };
  
    const isSameRoute = (url: string) => {
        const currentPath = sanitizePath(location.pathname);
        const urlWithoutParams = sanitizePath(url);

        const route = getMatchedRoute(currentPath);
        return route && matchPath(route, urlWithoutParams)
    };
  
    return { isSameRoute };
};
